import React, { FC, useState } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Button,
  Textarea,
  FormHelperText,
  useToast,
  Heading,
  Box,
  Stack,
} from "@chakra-ui/react";
import { PageHeader } from "shared/page-header/PageHeader";
import { ContactPageId } from "utils/useScroll";

export const Contact: FC = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const toast = useToast();

  const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setFullName(e.target.value);
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value);
  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!fullName || !email || !message) {
      setIsError(true);
      toast({
        title: "Please fill out all fields.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsError(false);

    toast({
      title: "Sending Message",
      duration: 3000,
      isClosable: true,
    });

    const formData = new FormData(e.target as HTMLFormElement);

    formData.append("access_key", "8c5c24d1-2b76-4459-b936-05d6234f61c0");
    console.log(formData.get('fullName'));
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
        toast({
            title: "Message Sent, I will contact your shortly",
            status : "success",
            duration: 3000,
            isClosable: true,
          });
      setFullName('');
      setEmail('');
     setMessage('');
     (e.target as HTMLFormElement).reset();
    } else {
        toast({
            title: "Message Failed, Please try again",
            status : "error",
            duration: 3000,
            isClosable: true,
          });

    }

    // Clear fields
    
  };


  


  return (
    <Box id={ContactPageId}>
            <PageHeader label="Contact Me" />
       <Box w="100%" p={6} boxShadow="md" borderRadius="lg">
        <Heading mb={6} textAlign="center" size="lg">
          Need a service or have a question, drop me a message
        </Heading>
        <form onSubmit={handleSubmit}>
          <Stack spacing={4} w="100%">
            {/* Full Name */}
            <FormControl id="fullName" isRequired>
              <FormLabel>Full Name</FormLabel>
              <Input
                type="text"
                value={fullName}
                name="fullName"
                onChange={handleFullNameChange}
                placeholder="Enter Your Full Name"
                w="100%"
              />
            </FormControl>

            {/* Email */}
            <FormControl id="email" isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                name="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter Your Email"
                w="100%"
              />
              <FormHelperText>
                Enter the email you'd like me to contact you on.
              </FormHelperText>
            </FormControl>

            {/* Detailed Message */}
            <FormControl id="message" isRequired>
              <FormLabel>Detailed Message</FormLabel>
              <Textarea
                value={message}
                name="message"
                onChange={handleMessageChange}
                placeholder="Enter Your Message"
                size="lg"
                w="100%"
              />
              <FormHelperText>
                Feel free to share any additional details or questions.
              </FormHelperText>
            </FormControl>

            {/* Submit Button */}
            <Button
              colorScheme="blue"
              type="submit"
              isDisabled={!fullName || !email || !message}
              w="100%"
            >
              Send
            </Button>
          </Stack>
        </form>
      </Box>
    </Box>
  );
};
